require('./bootstrap');

require('alpinejs');

let element = document.querySelector('.toggle-menu');

element.onclick = function () {
    element.classList.toggle('is-active');

    document.querySelector('.mobile-menu').classList.toggle('hidden');
    document.querySelector('.mobile-menu').classList.toggle('opacity-0');
}

// When the user scrolls the page, execute myFunction
window.onscroll = function () {
    stickyHeader()
};

// Get the header
var header = document.getElementById("top-menu");

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyHeader() {
    if (header) {
        if (window.pageYOffset > 0) {
            header.classList.add("top-header-scrolled");
        } else {
            header.classList.remove("top-header-scrolled");
        }
    }
}

import Swiper, {Pagination} from 'swiper';
import 'swiper/swiper-bundle.css';

if (document.getElementsByClassName('has-swiper-wrapper').length > 0) {

    let init = false;
    let swiperPortfolio = Swiper;
    let swiperNews = Swiper;

    swiperPortfolio.use([Pagination]);
    swiperNews.use([Pagination]);

    function swiperMode() {
        let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');

        function enableClasses() {
            let swiperContainers = document.getElementsByClassName('has-swiper-container');
            for (let item of swiperContainers) {
                item.classList.add('swiper-container')
            }

            let swiperWrappers = document.getElementsByClassName('has-swiper-wrapper');
            for (let item of swiperWrappers) {
                item.classList.add('swiper-wrapper')
            }

            let swiperSlides = document.getElementsByClassName('has-swiper-slide');
            for (let item of swiperSlides) {
                item.classList.add('swiper-slide')
            }
        }

        function disableClasses() {
            let swiperSlides = document.getElementsByClassName('swiper-slide');
            for (let item of swiperSlides) {
                item.classList.remove('swiper-slide')
            }

            let swiperWrappers = document.getElementsByClassName('swiper-wrapper');
            for (let item of swiperWrappers) {
                item.classList.remove('swiper-wrapper')
            }
        }

        function loadSwiperPortfolio() {
            swiperPortfolio = new Swiper('.portfolio-slider', {
                slidesPerView: 1,
                spaceBetween : 10,
                pagination   : {
                    el            : '.swiper-pagination-portfolio',
                    dynamicBullets: false,
                },
            });
        }

        function loadSwiperNews() {
            swiperNews = new Swiper('.news-slider', {
                slidesPerView: 1,
                spaceBetween : 10,
                pagination   : {
                    el            : '.swiper-pagination-news',
                    dynamicBullets: false,
                },
                paginationClickable: true,
            });
        }

        // Enable (for mobile)
        if (mobile.matches) {
            if (!init) {
                init = true;
                enableClasses();
                loadSwiperPortfolio();
                loadSwiperNews();
            }
        } else {
            disableClasses();

            if (init) {
                try {
                    swiperPortfolio.destroy(true, true);
                } catch (error) {
                }
                try {
                    swiperNews.destroy(true, true);
                } catch (error) {
                }
            }

            init = false;
        }
    }

    window.addEventListener('load', function () {
        swiperMode();
    });

    window.addEventListener('resize', function () {
        swiperMode();
    });
}
